<template>
  <div>
    <div class="banner">
      <div class="headerReplacementBasicInfo"></div>
      <div class="banner-text">
        <b>{{ $t('shareholderMeetings.shareholderMeeting') }}</b>
        <div class="breadcrumb">
          <span>
            <router-link to="/" class="pe-auto">{{ $t('shareholderMeetings.investorHome') }}</router-link>
          </span>
          <span class="separator"></span>
          <span>{{ $t('shareholderMeetings.shareholderInfo') }}</span>
          <span class="separator"></span>
          <span><b>{{ $t('shareholderMeetings.shareholderMeeting') }}</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <BasicInfoTabMenu />
      </div>

      <!-- Year Select Dropdown -->
      <div class="row g-3 row justify-content-end mb-3">
        <div class="col-auto">
          <label class="col-form-label">{{ $t('shareholderMeetings.selectYear') }}</label>
        </div>
        <div class="col-auto">
          <select id="yearSelect" v-model="selectedYear" @change="selectDefaultMeetingType" class="form-select" aria-label="Year selection">
            <option value="2025">2025</option>
            <option value="2024">2024</option>
            <option value="2023">2023</option>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
            <!-- <option value="2020">2020</option> -->
          </select>
        </div>
      </div>

      <!-- Tabs for Meeting Types -->
      <div class="row mb-3">
        <div class="col">
          <ul class="nav nav-tabs nav-justified" id="meetingTabs" role="tablist">
            <li class="nav-item" v-for="(type, index) in sortedMeetingTypes" :key="index">
              <a class="nav-link" :class="{ active: selectedMeetingType == type }" @click="selectMeetingType(type)"
                href="javascript:void(0)">
                <span v-if="type == 0">{{ $t('shareholderMeetings.annualShareholdersMeeting') }} {{ selectedYear }}</span>
                <span v-else>{{ $t('shareholderMeetings.annualShareholdersMeeting') }} {{ type }}/{{ selectedYear }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Table of Meetings -->
      <table class="table mb-5">
        <thead>
          <tr class="table-secondary">
            <th scope="col">
              <b>{{ $t('shareholderMeetings.annualShareholdersMeeting') }} {{ $t('shareholderMeetings.meetingYear') }} {{ selectedYear }}</b>
            </th>
            <th scope="col" class="text-end"><b>{{ $t('shareholderMeetings.document') }}</b></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoading">
            <td colspan="2" class="text-center">
              <div class="d-flex justify-content-center align-items-center" style="height: 100px;">
                <div class="spinner-grow custom-spinner" role="status"></div>
              </div>
            </td>
          </tr>

          <tr v-for="(item, index) in filteredListByType" :key="index">
            <td style="width: 90%;">{{ item.meeting_name }}</td>
            <td class="text-end">
              <a :href="item.meeting_url" target="_blank" class="text-decoration-none">
                <p class="card-text text-secondary">
                  <small class="text-muted">
                    <i class="fa-solid fa-download"></i> {{ $t('shareholderMeetings.download') }}
                  </small>
                </p>
              </a>
            </td>
          </tr>

          <tr v-if="!isLoading && filteredListByType.length <= 0">
            <td colspan="2" class="text-center text-muted">
              <p class="mt-3">{{ $t('shareholderMeetings.noData') }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import store from "@/store";
import { GET_MEETINGS_DATA } from "../../store/actions.type";

export default {
  name: 'MajorShareholders',
  components: {
    BasicInfoTabMenu,
  },
  data() {
    return {
      selectedYear: '2025',
      selectedMeetingType: '0',
      list: [],
      meetingTypes: [],
      isLoading: false,
    };
  },
  computed: {
    sortedMeetingTypes() {
      return this.meetingTypes.sort((a, b) => b - a);
    },
    filteredList() {
      return this.list.filter(item => String(item.meeting_year) === String(this.selectedYear));
    },
    filteredListByType() {
      return this.filteredList
        .filter(item => {
          if (this.selectedMeetingType === '') return true;
          return String(item.meeting_type) === String(this.selectedMeetingType);
        })
        .sort((a, b) => a.meeting_id - b.meeting_id); // เรียงตาม meeting_id
    }
  },
  methods: {
    async loadMeetings() {
      this.isLoading = true;
      this.list = [];            // <-- เคลียร์ list ทันที
      this.meetingTypes = [];     // <-- เคลียร์ meetingTypes ด้วย
      const lang = this.$i18n.locale;
      try {
        const result = await store.dispatch(GET_MEETINGS_DATA, lang);
        this.list = result;
        // console.log('✅ Meetings data:', this.list);
        this.meetingTypes = [...new Set(this.list.map(item => item.meeting_type))];
      } catch (error) {
        console.error('❌ Error loading meetings', error);
      } finally {
        this.isLoading = false;
      }
    },
    selectMeetingType(type) {
      this.selectedMeetingType = type;
    },
    selectDefaultMeetingType() {
      this.selectedMeetingType = '0';
    }
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      async handler(lang) {
        this.isLoading = true;
        this.list = [];           // <-- เคลียร์ตอนเปลี่ยนภาษา
        this.meetingTypes = [];   // <-- เคลียร์ tab ด้วย
        await this.loadMeetings();
      }
    }
  }
};
</script>




<style scoped>
.nav-link {
  color: #000000;
}

.nav-link:hover {
  color: #000000;
}

.nav-link.active {
  color: #E87D2E;
  font-weight: bold;
}
</style>
